import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import api from '@common/utils/api';
import analytics from '@utils/analytics';
import ThronVideo from '@components/utils/ThronVideo';
import Button from '@common/ui/button/Button';
import '@moncler/scss/components/editorial-video-simplified/component-editorial-video-simplified.scss';
import VideoProgressBar from './VideoProgressBar';
import FocusTrap from 'focus-trap-react';
let firstTime = true;
const EditorialVideo = (props) => {
    var _a;
    const [componentData, setComponentData] = useState(null);
    const [thronID, setThronID] = useState(null);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [playerStatus, setPlayerStatus] = useState(false);
    const [hideControls, setHideControls] = useState(true);
    const videoRef = useRef();
    const fullScreenRef = useRef(false);
    useEffect(() => {
        var _a;
        let pageID = (_a = document.body.id) === null || _a === void 0 ? void 0 : _a.replace('page-', '');
        if (pageID) {
            api.getPageJson(pageID, true).then((data) => {
                var _a, _b;
                let componentDataRes = (_a = data.regions[0].components) === null || _a === void 0 ? void 0 : _a.find((c) => c.id === props.uuid);
                setComponentData(componentDataRes);
                setThronID((_b = componentDataRes === null || componentDataRes === void 0 ? void 0 : componentDataRes.data) === null || _b === void 0 ? void 0 : _b.thronID);
            });
        }
    }, []);
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        fullScreenRef.current = isFullScreen; // Ugly workaround, but thron's TS component callbacks are closured
        if (firstTime && isFullScreen) {
            firstTime = false;
            analytics.openedVideo((_a = componentData === null || componentData === void 0 ? void 0 : componentData.data) === null || _a === void 0 ? void 0 : _a.ctaText);
        }
        if (videoRef.current) {
            let muteButton = videoRef.current.querySelector('[data-mute]');
            let playButton = videoRef.current.querySelector('[data-pause]');
            let videoEl = videoRef.current.querySelector('video');
            if (isFullScreen) {
                // Change thronID to full screen one
                componentData.data.thronIDFullScreen && setThronID(componentData.data.thronIDFullScreen);
                setPlayerStatus(null);
                // Handle size change
                (_b = videoRef.current.closest('.video-module')) === null || _b === void 0 ? void 0 : _b.classList.add('no-padding');
                videoEl === null || videoEl === void 0 ? void 0 : videoEl.setAttribute('playsInline', true);
                videoEl === null || videoEl === void 0 ? void 0 : videoEl.setAttribute('autoPlay', true);
                videoEl === null || videoEl === void 0 ? void 0 : videoEl.setAttribute('loop', true);
                (_c = document.querySelector('header')) === null || _c === void 0 ? void 0 : _c.classList.add('video-full-screen');
                (_d = videoRef.current.closest('.video-module')) === null || _d === void 0 ? void 0 : _d.scrollIntoView({ block: 'center', behavior: 'instant' });
                setTimeout(() => {
                    var _a;
                    (_a = videoRef.current.closest('.video-module')) === null || _a === void 0 ? void 0 : _a.classList.add('full-screen');
                    document.body.style.overflowY = 'hidden';
                }, 300);
                if (muteButton.getAttribute('aria-pressed') === 'false') {
                    muteButton.click();
                }
                if (playButton.getAttribute('aria-pressed') === 'true') {
                    playButton.click();
                }
            }
            else {
                // Change thronID to normal one if was changed
                componentData.data.thronIDFullScreen && setThronID(componentData.data.thronID);
                // Handle size change
                (_e = videoRef.current.closest('.video-module')) === null || _e === void 0 ? void 0 : _e.classList.remove('full-screen');
                document.body.style.overflowY = 'scroll';
                setTimeout(() => {
                    var _a, _b;
                    (_a = document.querySelector('header')) === null || _a === void 0 ? void 0 : _a.classList.remove('video-full-screen');
                    (_b = videoRef.current.closest('.video-module')) === null || _b === void 0 ? void 0 : _b.classList.remove('no-padding');
                }, 200);
                if (muteButton.getAttribute('aria-pressed') === 'true') {
                    muteButton.click();
                }
            }
        }
    }, [isFullScreen]);
    if (!componentData) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(FocusTrap, { active: isFullScreen },
        React.createElement("div", { ref: videoRef, className: classNames('video-module__inner-container', 'video-container', `image-background--${componentData.data.imgGradient.toLowerCase()}`, `image-background--${componentData.data.gradientSize.toLowerCase()}`, { 'video-opened': isFullScreen }) },
            thronID && (React.createElement(ThronVideo, { thronID: thronID, onInitCallback: () => setHideControls(!fullScreenRef.current), onTimeUpdate: (playerInstance) => setPlayerStatus(playerInstance.status()) })),
            React.createElement("h2", { className: classNames('video-module__title', `primary-${(_a = componentData.data.headlineSize) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`, { hidden: isFullScreen }) }, componentData.data.title),
            React.createElement("div", { className: classNames('video-module__cta', { hidden: isFullScreen }) },
                React.createElement(Button, { type: "button", cls: ['button--tertiary-inverted', 'button--play-left'], onClick: () => setIsFullScreen(true), ariaExpanded: isFullScreen }, componentData.data.ctaText)),
            React.createElement("button", { className: classNames('close-icon', { hidden: !isFullScreen }), onClick: () => setIsFullScreen(false) }),
            React.createElement(VideoProgressBar, { playerStatus: playerStatus, videoRef: videoRef.current, hidden: hideControls }))));
};
export default EditorialVideo;
